import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../config/routes";

const NotFound: React.FC = () => {
  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to={ROUTES.home}>Go back to Home</Link>
    </div>
  );
};

export default NotFound;
